import { useState, useEffect } from 'react';

export default (dependencies, clearState) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    clearState?.();

    if (!loading) {
      setLoading(true);
    }
    setTimeout(() => {
      setLoading(false);
    }, 750);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependencies]);

  return loading;
};
